import { render, staticRenderFns } from "./CampaignCouponDiscountForm.vue?vue&type=template&id=c820a432&scoped=true"
import script from "./CampaignCouponDiscountForm.vue?vue&type=script&lang=js"
export * from "./CampaignCouponDiscountForm.vue?vue&type=script&lang=js"
import style0 from "./CampaignCouponDiscountForm.vue?vue&type=style&index=0&id=c820a432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c820a432",
  null
  
)

export default component.exports